import * as React from 'react';

/**
 * useMeasuredRef
 * @function useMeasuredRef Custom hook to get the dimensions of a node.
 * @param dependencies Any array of variables that might change that could effect the dimensions of the measuredRef
 * @param resize Boolean indicating to use resize event listener
 * @description Dimensions include {top, bottom, left, right, height, width, x, y}
 */
const useMeasuredRef = (dependencies: any[], resize?: boolean, fullscreen?: boolean) => {
  const [dimensions, setDimensions] = React.useState<ClientRect>(null);
  const measuredRef = React.useCallback(
    (node: HTMLElement) => {
      if (node !== null) {
        resize && window.addEventListener('resize', () => setDimensions(node.getBoundingClientRect()));
        fullscreen && window.addEventListener('fullscreenchange', () => setDimensions(node.getBoundingClientRect()));
        setDimensions(node.getBoundingClientRect());
      }
    },
    dependencies.length > 0 ? dependencies : []
  );

  return { measuredRef, dimensions };
};

export default useMeasuredRef;
